import CircleLoading from "@/components/circle-loading"

interface LoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number
}

export function Loading({ className, size = 16, ...props }: LoadingProps) {
  return (
    <div className={`animate-spin ${className || ''}`} {...props}>
      <CircleLoading size={size} />
    </div>
  )
} 